const localizers = {
  'loading.msg': () => `Yükleniyor...`,
  'SASServer.genericError.msg': () => `Sunucuya erişim sağlanamıyor.`,
  'SASReport.genericError.msg': () => `Seçili rapor yüklenemiyor.`,
  'SASReportImage.genericError.msg': () => `Rapor görüntüsü yüklenemedi.`,
  'SASReportImage.imageNotSupported.msg': () => `Görüntüler bu rapor içeriği tipinde desteklenmiyor.`,
}
export default localizers;
